import { Badge } from "@xola/ui-kit";
import React from "react";
import { Traveler } from "types";
import { isMergedRecord } from "../../../models/User";

export const MergedRecordBadge = ({ contact }: { contact: Traveler }) => {
    if (!isMergedRecord(contact)) {
        return null;
    }

    return (
        <Badge color="secondary" size="small">
            <span>Merged Record</span>
        </Badge>
    );
};
